var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#1D4ED8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2799 15.2812C22.3992 15.2286 22.5005 15.1421 22.5712 15.0324C22.6418 14.9228 22.6788 14.7948 22.6774 14.6644C22.6761 14.534 22.6365 14.4068 22.5636 14.2986C22.4907 14.1905 22.3876 14.1061 22.2672 14.0559L16.5532 11.4532C16.3795 11.374 16.1908 11.333 15.9999 11.333C15.8089 11.333 15.6202 11.374 15.4465 11.4532L9.7332 14.0532C9.61451 14.1052 9.51354 14.1907 9.44264 14.2991C9.37174 14.4076 9.33398 14.5343 9.33398 14.6639C9.33398 14.7935 9.37174 14.9202 9.44264 15.0287C9.51354 15.1372 9.61451 15.2226 9.7332 15.2746L15.4465 17.8799C15.6202 17.9591 15.8089 18.0002 15.9999 18.0002C16.1908 18.0002 16.3795 17.9591 16.5532 17.8799L22.2799 15.2812Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 14.6667V18.6667",
    stroke: "#1D4ED8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.3333V18.6666C12 19.197 12.4214 19.7057 13.1716 20.0808C13.9217 20.4559 14.9391 20.6666 16 20.6666C17.0609 20.6666 18.0783 20.4559 18.8284 20.0808C19.5786 19.7057 20 19.197 20 18.6666V16.3333",
    stroke: "#1D4ED8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmission);
export default __webpack_public_path__ + "static/media/admission.f712fe6d55958a86a380a4c5297c18f6.svg";
export { ForwardRef as ReactComponent };